'use strict';

function getConfigurationFromSettings(settings) {
  return settings.features || {};
}

module.exports = getConfigurationFromSettings;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/services/offline/browser.js
// module id = 1229
// module chunks = 0